import React, { Component } from "react";
import { connect } from "react-redux";

import { openMediaViewer, toggleSelectMedia, deleteEditorMedia } from "Actions";
import { openMediaEditor } from "Thunks";
import MediaComponent from "./MediaComponent";
import { userHasRights } from "Utils";
import { toast } from "react-toastify";
import _ from "i18n";

export class Media extends Component {
  handleOpenMediaReveal = e => {
    const { openMediaViewer, media } = this.props;

    openMediaViewer({
      medias: [media],
      isOpen: true,
      currentMedia: media
    });
    // }
  };

  handleDeleteMediaFromEditor = e => {
    e.stopPropagation();
    const { media, deleteEditorMedia } = this.props;
    deleteEditorMedia(media);
  };

  handleClickSelect = e => {
    e.stopPropagation();
    const { toggleSelectMedia, media } = this.props;
    toggleSelectMedia(media);
  };

  handleOpenMediaEditor = e => {
    const { media, auth, openMediaEditor } = this.props;

    e.stopPropagation();
    if (!userHasRights(auth, media)) {
      return toast.error(
        <div>
          <span>{_("You are not allowed to do this action.")}</span>
        </div>,
        { autoClose: true }
      );
    }
    openMediaEditor(media);
  };

  render() {
    return (
      <MediaComponent
        {...this.props}
        openMediaReveal={this.handleOpenMediaReveal}
        handleClickSelect={this.handleClickSelect}
        openMediaEditor={this.handleOpenMediaEditor}
        deleteMediaFromEditor={this.handleDeleteMediaFromEditor}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  language: state.params.lng,
  checks: state.medias.listing.checks,
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  openMediaViewer: viewer => dispatch(openMediaViewer(viewer)),
  toggleSelectMedia: media => dispatch(toggleSelectMedia(media)),
  openMediaEditor: media => dispatch(openMediaEditor(media)),
  deleteEditorMedia: media => dispatch(deleteEditorMedia(media))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Media);



// WEBPACK FOOTER //
// ./src/components/Common/Media/index.js